import { createRouter, createWebHistory } from 'vue-router'

import Login from '../components/LoginComponent'
import MainLayout from '@/views/MainView.vue';

const routes = [
    {
        path: '/',
        component: Login
    },
    {
        name: 'login',
        path: '/login',
        component: Login
    },
    {
        name: 'main',
        path: '/main',
        component: MainLayout,
        children: [
          {
            path: 'userApply',
            name: 'userApply',
            component: () => import('@/views/UserApply/UserApplyView.vue')
          },
          {
            path: 'userAuthLog',
            name: 'userAuthLog',
            component: () => import('@/views/UserAuthLog/UserAuthLogView.vue')
          },
          {
            path: 'userVMLog',
            name: 'userVMLog',
            component: () => import('@/views/UserVMLog/UserVMLogView.vue')
          },
          {
            path: 'scriptLog',
            name: 'scriptLog',
            component: () => import('@/views/ScriptLog/ScriptLogView.vue')
          },
          {
            path: 'rdpDownLoadLog',
            name: 'rdpDownLoadLog',
            component: () => import('@/views/RdpDownLoadLog/RdpDownLoadLogView.vue')
          },
          {
            path: 'userInfo',
            name: 'userInfo',
            component: () => import('@/views/UserInfo/UserInfoView.vue')
          },
          {
            path: 'announcementsList',
            name: 'announcementsList',
            component: () => import('@/views/Announcements/AnnouncementsListView.vue')
          },
          {
            name: 'announcementsRegistration',
            path: 'announcementsRegistration',
            component: () => import('@/views/Announcements/AnnouncementsRegistration.vue')
          },
          {
            name: 'announcementsItem',
            path: 'announcementsItem/:id',
            component: () => import('@/views/Announcements/AnnouncementsItemView.vue')
          },
          {
            name: 'announcementsModification',
            path: 'announcementsModification/:id',
            component: () => import('@/views/Announcements/AnnouncementsModification.vue')
          },
          {
            path: 'popupAnnouncementsList',
            name: 'popupAnnouncementsList',
            component: () => import('@/views/PopupAnnouncements/PopupAnnouncementsListView.vue')
          },
          {
            name: 'popupAnnouncementsRegistration',
            path: 'popupAnnouncementsRegistration',
            component: () => import('@/views/PopupAnnouncements/PopupAnnouncementsRegistration.vue')
          },
          {
            name: 'popupAnnouncementsItem',
            path: 'popupAnnouncementsItem/:id',
            component: () => import('@/views/PopupAnnouncements/PopupAnnouncementsItemView.vue')
          },
          {
            name: 'popupAnnouncementsModification',
            path: 'popupAnnouncementsModification/:id',
            component: () => import('@/views/PopupAnnouncements/PopupAnnouncementsModification.vue')
          },
          {
            path: 'faqList',
            name: 'faqList',
            component: () => import('@/views/FAQ/FAQListView.vue')
          },
          {
            path: 'faqRegistration',
            name: 'faqRegistration',
            component: () => import('@/views/FAQ/FAQRegistration.vue')
          },
          {
            path: 'faqModification/:id',
            name: 'faqModification',
            component: () => import('@/views/FAQ/FAQModification.vue')
          },
          {
            path: 'dashBoard',
            name: 'dashBoard',
            component: () => import('@/views/DashBoard/UserDashBoardView.vue')
          },
          {
            path: 'resource',
            name: 'resource',
            component: () => import('@/views/Resource/ResourceListView.vue')
          },
        ]
      },
]

const router = createRouter({
    history: createWebHistory(),
    routes
});

export {router}